export default "__VITE_ASSET__dFfQ5rJs__"